/* screens/admin/AdminHub.jsx — хаб внутренних сервисов («Админка»).
   Открывается из сайдбара (только у staff с доступом). Плитки = микросервисы;
   первый — CRM. Клик по плитке открывает сервис (/admin/<service>). */
import React from 'react';
import { PageHeader } from '../../components/patterns/PageHeader.jsx';
import { Icon } from '../../components/ui/Icon.jsx';
import { Pill } from '../../components/ui/Badge.jsx';
import { useAuth } from '../../app/providers/AuthProvider.jsx';
import { RR } from '../../lib/router.jsx';
import { hasPlansAccess, plansTileDesc } from '../sales/plansAccess.js';

const { useNavigate } = RR;

function ServiceTile({ icon, title, desc, badge, to, disabled }) {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      className={'admin-tile' + (disabled ? ' admin-tile--soon' : '')}
      onClick={disabled ? undefined : () => navigate(to)}
      disabled={disabled}
    >
      <span className="admin-tile__icon"><Icon name={icon} size={24} /></span>
      <span className="admin-tile__body">
        <span className="admin-tile__head">
          <span className="admin-tile__title">{title}</span>
          {badge}
        </span>
        <span className="admin-tile__desc">{desc}</span>
      </span>
      {!disabled && <Icon name="chevron-right" size={18} className="admin-tile__go" />}
    </button>
  );
}

function AdminHub() {
  const { user } = useAuth();
  const isAdmin = !!user?.crm_admin;
  return (
    <div className="section-page">
      <PageHeader subtitle="Внутренние сервисы" title="Админка" />
      <div className="section-body">
        <div className="admin-hub">
          {user?.crm_access && (
            <ServiceTile
              icon="layers"
              title="CRM · Воронки продаж"
              badge={<Pill tone={isAdmin ? 'accent' : 'neutral'} size="sm">{isAdmin ? 'Админ' : 'Работа'}</Pill>}
              desc="Лиды, воронки, перемещения с обязательной причиной, заметки, приём заявок по API."
              to="/console/crm"
            />
          )}
          {isAdmin && (
            <ServiceTile
              icon="settings"
              title="CRM · Настройка воронок"
              badge={<Pill tone="neutral" size="sm">Админ</Pill>}
              desc="Конструктор: воронки, их этапы и приём заявок по API — всё в одном месте."
              to="/console/crm/settings"
            />
          )}
          {user?.tracker_access && (
            <ServiceTile
              icon="calendar"
              title="Задачи"
              badge={<Pill tone="accent" size="sm">Разработка</Pill>}
              desc="План разработки: этапы и задачи, статусы и сроки, диаграмма Ганта, комментарии и история изменений."
              to="/console/tasks"
            />
          )}
          {user?.broadcasts_access && (
            <ServiceTile
              icon="send"
              title="Рассылки"
              badge={<Pill tone="accent" size="sm">Маркетинг</Pill>}
              desc="Рассылки в Telegram и на почту: каналы, аудитория, предпросмотр, тест и мониторинг."
              to="/console/broadcasts"
            />
          )}
          {user?.support_access && (
            <ServiceTile
              icon="chat"
              title="Поддержка"
              badge={<Pill tone="accent" size="sm">Поддержка</Pill>}
              desc="Обращения пользователей: переписка, ответы, статусы — встроенный чат поддержки."
              to="/console/support"
            />
          )}
          {/* «Тарифы» — по любому из двух независимых прав; описание говорит
              только о том, что человеку откроется (plansAccess.js). */}
          {hasPlansAccess(user) && (
            <ServiceTile
              icon="tag"
              title="Тарифы"
              badge={<Pill tone="neutral" size="sm">Продажи</Pill>}
              desc={plansTileDesc(user)}
              to="/console/plans"
            />
          )}
          {user?.payment_links_access && (
            <ServiceTile
              icon="link"
              title="Ссылки на оплату"
              badge={<Pill tone="accent" size="sm">Продажи</Pill>}
              desc="Именная ссылка клиенту на любой тариф — публичный или закрытый. Отзыв, срок действия, статус оплаты."
              to="/console/payment-links"
            />
          )}
          {user?.academy_access && (
            <ServiceTile
              icon="book"
              title="Академия"
              badge={<Pill tone={user?.academy_manage ? 'accent' : 'neutral'} size="sm">
                {user?.academy_manage ? 'Методист' : 'Куратор'}</Pill>}
              desc="Обучающие курсы: конструктор уроков, тесты с авто-проверкой и проверка домашних заданий."
              to="/console/academy"
            />
          )}
          {user?.utm_access && (
            <ServiceTile
              icon="link"
              title="UTM-метки"
              badge={<Pill tone="accent" size="sm">Маркетинг</Pill>}
              desc="Короткие ссылки по каналам привлечения: переходы, регистрации, оплаты и выручка по каждой метке."
              to="/console/utm"
            />
          )}
          {/* Плитка-заглушка рендерится безусловно и обязана оставаться ПОСЛЕДНЕЙ:
              любой новый модуль вставляем перед ней, иначе он окажется ниже «Скоро». */}
          <ServiceTile
            icon="clock"
            title="Скоро"
            desc="Здесь появятся другие внутренние инструменты команды."
            disabled
          />
        </div>
      </div>
    </div>
  );
}

export { AdminHub };
